import * as React from 'react';
import {Component} from 'react';
import {connect} from 'react-redux';

import NormalOrders from '../../screens/NormalOrders';

import {
  fetchNormalOrders,
  newpageSelected,
  inprogressOrders,
  progresspageSelected,
  deliveredOrders,
  deliveredpageSelected,
  cancelledOrders,
  cancelledpageSelected,
  ChemistNormalOrdersview,
  NormalOrderEdit,
  NormalOrderReject,
  Totalitemretrieval,
  manualInvoice,
  fetchNormalorderdlryStatus,
  NormalordersShipped,
  itempageSelected,
  itemViewpageSelected,
  changePaymentstatusnormal,
  pdfFullData,
  searchChemistitems,
} from './action';

class NormalOrdersContainer extends Component {
  render() {
    return (
      <NormalOrders
        fetchNormalOrders={this.props.fetchNormalOrders}
        normalorderDetailsfromChemists={
          this.props.normalorderDetailsfromChemists
        }
        normalorderDetailsfromChemistsCount={
          this.props.normalorderDetailsfromChemistsCount
        }
        newpageSelected={this.props.newpageSelected}
        newOrdersList={this.props.newOrdersList}
        newOrdersListCount={this.props.newOrdersListCount}
        processedOrdersList={this.props.processedOrdersList}
        processedOrdersListCount={this.props.processedOrdersListCount}
        deliveredOrdersList={this.props.deliveredOrdersList}
        deliveredOrdersListCount={this.props.deliveredOrdersListCount}
        cancelledOrdersList={this.props.cancelledOrdersList}
        cancelledOrdersListCount={this.props.cancelledOrdersListCount}
        inprogressOrders={this.props.inprogressOrders}
        progresspageSelected={this.props.progresspageSelected}
        deliveredOrders={this.props.deliveredOrders}
        deliveredpageSelected={this.props.deliveredpageSelected}
        cancelledOrders={this.props.cancelledOrders}
        cancelledpageSelected={this.props.cancelledpageSelected}
        ChemistNormalOrdersview={this.props.ChemistNormalOrdersview}
        normalOrderDtls={this.props.normalOrderDtls}
        normalOrderDtlsCount={this.props.normalOrderDtlsCount}
        NormalOrderEdit={this.props.NormalOrderEdit}
        NormalOrderReject={this.props.NormalOrderReject}
        Totalitemretrieval={this.props.Totalitemretrieval}
        completeitemDetails={this.props.completeitemDetails}
        completeitemDetailsCount={this.props.completeitemDetailsCount}
        manualInvoice={this.props.manualInvoice}
        fetchNormalorderdlryStatus={this.props.fetchNormalorderdlryStatus}
        normaldlvrystatusList={this.props.normaldlvrystatusList}
        NormalordersShipped={this.props.NormalordersShipped}
        itempageSelected={this.props.itempageSelected}
        itemViewpageSelected={this.props.itemViewpageSelected}
        changePaymentstatusnormal={this.props.changePaymentstatusnormal}
        pdfFullData={this.props.pdfFullData}
        searchChemistitems={this.props.searchChemistitems}
        normalOrderSearchList={this.props.normalOrderSearchList}
        normalOrderSearchCount={this.props.normalOrderSearchCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchNormalOrders: value => {
      dispatch(fetchNormalOrders(value));
    },
    newpageSelected: value => {
      dispatch(newpageSelected(value));
    },
    inprogressOrders: value => {
      dispatch(inprogressOrders(value));
    },
    progresspageSelected: value => {
      dispatch(progresspageSelected(value));
    },
    deliveredOrders: value => {
      dispatch(deliveredOrders(value));
    },
    deliveredpageSelected: value => {
      dispatch(deliveredpageSelected(value));
    },
    cancelledOrders: value => {
      dispatch(cancelledOrders(value));
    },
    cancelledpageSelected: value => {
      dispatch(cancelledpageSelected(value));
    },
    ChemistNormalOrdersview: value => {
      dispatch(ChemistNormalOrdersview(value));
    },
    NormalOrderEdit: value => {
      dispatch(NormalOrderEdit(value));
    },
    NormalOrderReject: value => {
      dispatch(NormalOrderReject(value));
    },
    Totalitemretrieval: value => {
      dispatch(Totalitemretrieval(value));
    },
    manualInvoice: value => {
      dispatch(manualInvoice(value));
    },
    fetchNormalorderdlryStatus: () => {
      dispatch(fetchNormalorderdlryStatus());
    },
    NormalordersShipped: value => {
      dispatch(NormalordersShipped(value));
    },
    itempageSelected: value => {
      dispatch(itempageSelected(value));
    },
    itemViewpageSelected: value => {
      dispatch(itemViewpageSelected(value));
    },
    changePaymentstatusnormal: value => {
      dispatch(changePaymentstatusnormal(value));
    },
    pdfFullData: value => {
      dispatch(pdfFullData(value));
    },
    searchChemistitems: value => {
      console.log('#########1111111111111111', value);
      dispatch(searchChemistitems(value));
    },
  };
}

const mapStateToProps = state => {
  return {
    normalorderDetailsfromChemists:
      state.NormalOrderReducer.normalorderDetailsfromChemists,
    normalorderDetailsfromChemistsCount:
      state.NormalOrderReducer.normalorderDetailsfromChemistsCount,
    newOrdersList: state.NormalOrderReducer.newOrdersList,
    newOrdersListCount: state.NormalOrderReducer.newOrdersListCount,
    processedOrdersList: state.NormalOrderReducer.processedOrdersList,
    processedOrdersListCount: state.NormalOrderReducer.processedOrdersListCount,
    deliveredOrdersList: state.NormalOrderReducer.deliveredOrdersList,
    deliveredOrdersListCount: state.NormalOrderReducer.deliveredOrdersListCount,
    cancelledOrdersList: state.NormalOrderReducer.cancelledOrdersList,
    cancelledOrdersListCount: state.NormalOrderReducer.cancelledOrdersListCount,

    normalOrderDtls: state.NormalOrderReducer.normalOrderDtls,
    normalOrderDtlsCount: state.NormalOrderReducer.normalOrderDtlsCount,

    completeitemDetails: state.NormalOrderReducer.completeitemDetails,
    completeitemDetailsCount: state.NormalOrderReducer.completeitemDetailsCount,
    normaldlvrystatusList: state.NormalOrderReducer.normaldlvrystatusList,

    normalOrderSearchList: state.NormalOrderReducer.normalOrderSearchList,
    normalOrderSearchCount: state.NormalOrderReducer.normalOrderSearchCount,
  };
};

export default connect(mapStateToProps, bindAction)(NormalOrdersContainer);
